// --- Modules
import Node, { payload } from './Node';

class Switch extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Switch'
    });
  }
};

export default {
  create: (opts) => {
    let item = new Switch(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
